import React from 'react'
import moment from 'moment'
import _ from 'underscore'
import numeral from 'numeral'
import AutoComplete from '../components/react-autocomplete'
import NumericTextBox from '../components/react-numerictextbox'

var CURRENCIES = [
  {ccy: 'GBPUSD', symbol: 'GBP='},
  {ccy: 'EURUSD', symbol: 'EUR='},
  {ccy: 'USDJPY', symbol: 'JPY='},
  {ccy: 'USDCHF', symbol: 'CHF='},
  {ccy: 'USDCAD', symbol: 'CAD='},
  {ccy: 'AUDUSD', symbol: 'AUD='},
]

export default class FXStreamWidget extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			savedLayout : props.savedLayout || {},

			symbol : '',
			currencies : CURRENCIES,
			quote : {},

			quantity : 0,
			accounts : [],
			sendingOrder : false,
		}

		this._showQuotebands = true;
	}

	saveLayout() {
		if (window.updateLayout) {
			if (this.state.symbol)
				window.updateLayout({
					symbol : this.state.symbol,
				})
		}
	}

	componentDidMount() {
    //layout
    if (this.props.onResize)
      this.props.onResize(225,115)

    //sockets
    realtime().then( (socket) => {
      this._px_socket = socket

			socket.onjson = (m) => {
				if (!(m.symbol)) return
				if (m.symbol != this.state.symbol) {
					this._px_socket.unsubscribe("pricefeed.Quote.RIC:" + m.symbol)
					return
				}
				Object.assign(this.state.quote, m)
				this.renderQuote(m)
			}

    	//load from saved state
			let savedSymbol = this.state.savedLayout.symbol || this.props.symbol
    	if (savedSymbol) {
        for (var i = 0; i < CURRENCIES.length; i++) {
          if (CURRENCIES[i].symbol == savedSymbol) {
        		this.refs.txtSymbol.setValue(CURRENCIES[i].ccy);
        		this.handleSymbolChanged(savedSymbol);
          }
        }
    	}
    })
	}

	componentWillUnmount() {
    if (this._px_socket) this._px_socket.close()
	}

	handleSymbolChanged(symbol) {
		if (this.state.symbol)
			this._px_socket.unsubscribe("pricefeed.Quote.RIC:" + this.state.symbol)

		this.setState({
			symbol : symbol,
			currencies : CURRENCIES,
			accounts : [],
			quote : {},
		}, () => {

			// Subscribe Reuters
			this._px_socket.subscribe("pricefeed.Quote.RIC:" + symbol)

			// Get initial
	    api('/quote?symbol='+symbol)
	      .then( (res) => {
					console.log(symbol, "INITIAL => ", res)
					Object.assign(this.state.quote, res)
					this.renderQuote(res)
					if (this.props.onTitle && res.description) {
						this.props.onTitle(res.description)
					}

          this.saveLayout()
	      }).catch( (e) => {throw e} )
		})
	}

	handleExpandQuoteBandsClick() {
		if (this._showQuotebands) {
	    	$(this.refs.btnExpandQuoteBands).removeClass('active');
	    	$(this.refs.divQuoteBands).hide();
	    	this._showQuotebands = false;
		} else {
	    	$(this.refs.btnExpandQuoteBands).addClass('active');
	    	$(this.refs.divQuoteBands).show();
	    	this._showQuotebands = true;
		}
	}

	renderQuote(quote) {
    //Best Bid
    var bset_bid = _.max(_.map(this.state.quote, function(val, prop) {
    										if (prop.length == 4 && prop.startsWith('bid'))
    											return val;
    										return 0
    									   }));
    //Best Offer
    var bset_ask = _.min(_.map(this.state.quote, function(val, prop) {
    										if (prop.length == 4 && prop.startsWith('ask'))
    											return val;
    										return Number.MAX_SAFE_INTEGER;
    									   }));
    if (bset_ask === Number.MAX_SAFE_INTEGER)
    	bset_ask = 0;
    //Update best quote button prices
    var multiplier = 10000
    if ((''+Math.floor(bset_bid * 10)).length > 2)
    	multiplier = 100;

    var base = (Math.floor(+(bset_bid) * (multiplier / 100)) / (multiplier / 100))
    var pip = +(bset_bid) * multiplier
    pip = pip - (base * multiplier);
    var pipF = pip * 10 - Math.floor(pip)*10
    pip = Math.floor(pip)
    if (isNaN(pip)) pip = 0
    if (isNaN(base)) base = 0
    if (isNaN(pipF)) pipF = 0
    if ((''+pip).length == 1)
    	pip = '0' + pip
    $(this.refs.best_bid).html(numeral(base).format('0,0.[00]'));
    $(this.refs.best_bid_pip).html(pip);
    $(this.refs.best_bid_pipf).html(numeral(pipF).format('0[.]0'));

    var base = (Math.floor(+(bset_ask) * (multiplier / 100)) / (multiplier / 100))
    var pip = +(bset_ask) * multiplier
    pip = pip - (base * multiplier);
    var pipF = pip * 10 - Math.floor(pip)*10
    pip = Math.floor(pip)
    if (isNaN(pip)) pip = 0
    if (isNaN(base)) base = 0
    if (isNaN(pipF)) pipF = 0
    if ((''+pip).length == 1)
    	pip = '0' + pip
    $(this.refs.best_ask).html(numeral(base).format('0,0.[00]'));
    $(this.refs.best_ask_pip).html(pip);
    $(this.refs.best_ask_pipf).html(numeral(pipF).format('0[.]0'));

    if (_.isNumber(+bset_bid) && _.isNumber(+bset_ask)) {
    	var spread = (bset_ask - bset_bid) * multiplier;
    	$(this.refs.baSpread).html(numeral(spread).format('0,0.0'));
    }
	}

  render() {
  return (
  <div ref="widget" className="tickettrading widget" style={{ width:'210px' }}>
  	<div className="pnlbestprice row" style={{display : 'inline-block', width: '100%'}}>
  		<div className="col-xs-6" style={{padding : 0}}>
  			<div className="btnSell sidebutton sidebutton-left">
  				<span className="pricequote"><span ref="best_bid"/><span ref="best_bid_pip" className='pip'/><span ref="best_bid_pipf"/></span>
  				<span className="sidetag">SELL</span>
  			</div>
  		</div>
  		<div className="col-xs-6" style={{padding : 0}}>
  			<div className="btnBuy sidebutton sidebutton-right">
  				<span className="pricequote"><span ref="best_ask"/><span ref="best_ask_pip" className='pip'/><span ref="best_ask_pipf"/></span>
  				<span className="sidetag">BUY</span>
  			</div>
  		</div>
  		<div ref="baSpread" className="pnlSpread"></div>
  	</div>
          <div ref="orderbar" className="orderbar">
          <div className="control">
              <span className="label">Currency</span>
              <AutoComplete ref="txtSymbol" dataSource={ this.state.currencies }
                      dataTextField={"ccy"}
                      forceUpperCase={true}
              			  width={ 60 }
              			  onChange={ (ccy) => {
                        let symbol
                        for (var i = 0; i < this.state.currencies.length; i++) {
                          if (this.state.currencies[i].ccy == ccy) {
                            symbol = this.state.currencies[i].symbol
                            break
                          }
                        }
                        if (symbol)
                          this.handleSymbolChanged(symbol)
                      } } />
          </div>
          <div className="control">
              <span className="label">Quantity</span>
              <NumericTextBox ref="txtQuantity" width={ 109 } decimals={0} format='n0' min={0}/>
          </div>
  		{/*<div className="control">
          	<a ref="btnExpandQuoteBands" id="btnExpandQuoteBands" className="btn btn-default" style={{height: '23px', width: '23px', padding: 0,textAlign: 'center'}}
  			   title="Expand Quote Bands"
  			   onClick={ (e) => this.handleExpandQuoteBandsClick(e) }><i className="glyphicon glyphicon-chevron-down"></i></a>
  		</div>*/}

  	</div>
  	<div ref="divQuoteBands">
  		<table id="bidlayers" className="table table-hover" style={{fontSize: '10px',width:'50%',display: 'inline-block', verticalAlign: 'top'}}>
  		    <thead>
  		      <tr>
  		        <td>Qty</td>
  		        <td style={{width: '99%',textAlign: 'center'}}>Bid</td>
    		        <td>CP</td>
  		      </tr>
  		    </thead>
  		    <tbody>
  		    {
  	            _.map([1,2,3,4,5], (key) => {
  	            	if (this.state.quote['bid' + key] && this.state.quote['bid' + key] !== 0) {
  	            		return (
  	            			<tr key={ "bid" + key }>
  	            				<td style={{textAlign: 'right'}}>{numeral(this.state.quote['bid' + key + 'Size']).format('0,0')}</td>
  	            				<td>{this.state.quote['bid' + key]}</td>
                        <td></td>
  	            			</tr>
  	            		)
  	            	}
  	            })
  	        }
  		    </tbody>
  		</table>
  		<table id="asklayers" className="table table-hover" style={{fontSize: '10px',width:'50%',display: 'inline-block', verticalAlign: 'top'}}>
  		    <thead>
  		      <tr>
  		        <td style={{width: '99%',textAlign: 'center'}}>Ask</td>
  		        <td>Qty</td>
    		        <td>CP</td>
  		      </tr>
  		    </thead>
  		    <tbody>
  		    {
  	            _.map([1,2,3,4,5], (key) => {
  	            	if (this.state.quote['ask' + key] && this.state.quote['ask' + key] !== 0) {
  	            		return (
  	            			<tr key={ "ask" + key }>
  	            				<td>{this.state.quote['ask' + key]}</td>
  	            				<td style={{textAlign: 'right'}}>{numeral(this.state.quote['ask' + key + 'Size']).format('0,0')}</td>
                        <td></td>
  	            			</tr>
  	            		)
  	            	}
  	            })
  	        }
  		    </tbody>
  		</table>
  	</div>
  </div>);
  }

}



// WEBPACK FOOTER //
// ./src/widgets/fxstream.jsx